module.exports = __webpack_public_path__ + "static/home-banner-02-1e6e11f69e3ecf4f73bfe85b2843fbb4.jpg";